import * as colors from './colors'

export default { colors }



// WEBPACK FOOTER //
// ./src/core/styles/index.js